function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 22.5H1.5V21H22.5V22.5ZM3 11.25H11.25V19.5H3V11.25ZM3 1.5H11.25V9.75H3V1.5ZM12.75 11.25H21V19.5H12.75V11.25ZM12.75 1.5H21V9.75H12.75V1.5ZM23.78 19.72C23.64 19.579 23.449 19.5 23.25 19.5H22.5V1.5C22.5 1.102 22.342 0.720999 22.061 0.438999C21.779 0.157999 21.398 0 21 0H3C2.602 0 2.221 0.157999 1.939 0.438999C1.658 0.720999 1.5 1.102 1.5 1.5V19.5H0.75C0.551 19.5 0.36 19.579 0.22 19.72C0.079 19.86 0 20.051 0 20.25V23.25C0 23.449 0.079 23.64 0.22 23.78C0.36 23.921 0.551 24 0.75 24H23.25C23.449 24 23.64 23.921 23.78 23.78C23.921 23.64 24 23.449 24 23.25V20.25C24 20.051 23.921 19.86 23.78 19.72Z",
  fill: "black"
});

function SvgWindowClosed(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowClosed);
export default __webpack_public_path__ + "static/media/window-closed.83f858ca.svg";
export { ForwardRef as ReactComponent };